export default function MenuDotsIcon(props) {
  return (
    <svg
      viewBox="0 0 27 5"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="24.5" cy="2.5" r="2.5" fill="inherit" />
      <circle cx="13.5" cy="2.5" r="2.5" fill="inherit" />
      <circle cx="2.5" cy="2.5" r="2.5" fill="inherit" />
    </svg>
  )
}
